import { useEffect, useRef, useState } from "react";
import reactCSS from "reactcss";
import { fieldData } from "./constants";
import Draggable from "react-draggable";
import SelectBox from "../../../images/components/SelectBox";
import { SketchPicker } from "react-color";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../actions";
import NumberFormat from "react-number-format";
import { showAlert as showAlertUtil } from "../../../../config/utils";
import { ERROR_COPY } from "../../../../config/errorMessages";

const DynamicForm = ({
    entity,
    nameFieldValue,
    onCancel,
    projectId,
    autoFields,
    dropDownOptions,
    onFormSubmit,
    isMobileRecommendation,
    clientId
}) => {
    const [basicData, setBasicData] = useState(null);
    const [showErrorBorder, setShowErrorBorder] = useState({});
    const [errorMessage, setErrorMessage] = useState("");
    const [initialData, setInitialData] = useState(null);
    const [showPicker, setShowPicker] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const dispatch = useDispatch();
    const touchRef = useRef();
    const addRef = useRef();
    const { getDynamicDropdownDataResponse, getDynamicDropdownDataResponseLoading, addDynamicFormResponse, addDynamicFormResponseLoading } =
        useSelector(state => state.assetSurveyProjectReducer);

    useEffect(() => {
        return () => {
            dispatch(actions.resetDynamicDropdownData());
        };
    }, []);

    useEffect(() => {
        const fieldKeys = fieldData?.[entity]?.fieldKeys;
        const fields = fieldData?.[entity]?.fields;
        const nameField = fieldData?.[entity]?.nameField;
        if (fieldKeys) {
            const tempData = fieldKeys.reduce((acc, item) => {
                const defaultValue = fields?.[item]?.defaultValue;
                acc = {
                    ...acc,
                    [item]: item === nameField ? nameFieldValue : defaultValue ? defaultValue : autoFields[fields?.[item]?.autoFieldKey] ?? ""
                };
                return acc;
            }, {});
            setInitialData(tempData);
            setBasicData(tempData);
        }
    }, [entity, nameFieldValue]);
    useEffect(() => {
        if (autoFields) {
            const fields = fieldData?.[entity]?.fields;
            Object.keys(fields).forEach(eachKey => {
                const serviceFn = fields?.[eachKey]?.dropdownFn;
                if (serviceFn) {
                    const params = (fields?.[eachKey]?.paramFields ?? [])?.reduce((acc, item) => {
                        acc = { ...acc, [item === "project_ids" ? "project_id" : item]: autoFields?.[item] };
                        return acc;
                    }, {});
                    dispatch(actions.getDynamicDropdownData(fields?.[eachKey]?.dropdownField, () => serviceFn(params)));
                }
            });
        }
    }, [autoFields]);

    const showAlert = () => showAlertUtil(alertMessage);

    useEffect(() => {
        if (alertMessage) {
            showAlert();
            setAlertMessage("");
        }
    }, [alertMessage]);

    useEffect(() => {
        if (addRef?.current)
            if (addDynamicFormResponse) {
                addRef.current = false;
                const { success, message = "", data = {}, detail = null } = addDynamicFormResponse;
                if (success) {
                    setAlertMessage(`${fieldData?.[entity]?.formHeading} added successfully`);
                    setTimeout(() => {
                        onCancel();
                        onFormSubmit(basicData, data?.id);
                    }, 1000);
                } else {
                    setAlertMessage(typeof detail === "string" ? detail : message ? message : ERROR_COPY.GENERIC);
                }
            }
    }, [addDynamicFormResponse]);

    const validateData = onChangeData => {
        const tempData = onChangeData ? onChangeData : basicData;
        let tempErrorBoundary = {};
        let temprrorMessage = "";
        let hasError = false;
        const fields = fieldData?.[entity]?.fields;
        Object.keys(fields).forEach(eachKey => {
            const field = fields?.[eachKey];
            const isMandatory = field?.mandatory;
            if (
                isMandatory &&
                ((typeof tempData?.[eachKey] !== "number" && !tempData?.[eachKey]?.trim()?.length) ||
                    (typeof tempData?.[eachKey] === "number" && tempData?.[eachKey] === ""))
            ) {
                if (!temprrorMessage) temprrorMessage = `${field?.label} is required.`;
                tempErrorBoundary = { ...tempErrorBoundary, [eachKey]: true };
                hasError = true;
            }
        });
        setShowErrorBorder(tempErrorBoundary);
        setErrorMessage(temprrorMessage);
        return hasError;
    };

    const handleChange = e => {
        const { value, name } = e?.target;
        setBasicData({ ...basicData, [name]: value });
        touchRef?.current && validateData({ ...basicData, [name]: value ?? "" });
    };

    const styles = reactCSS({
        default: {
            color: {
                width: "40px",
                height: "15px",
                borderRadius: "3px",
                background: basicData?.color_code
            },
            popover: {
                position: "absolute",
                zIndex: "3"
            },
            cover: {
                position: "fixed",
                top: "0px",
                right: "0px",
                bottom: "0px",
                left: "0px"
            },
            swatch: {
                padding: "6px",
                background: "#ffffff",
                borderRadius: "2px",
                cursor: "pointer",
                display: "inline-block",
                boxShadow: "0 0 0 1px rgba(0,0,0,.2)"
            }
        }
    });

    const onColorClick = () => {
        setShowPicker(!showPicker);
    };

    const handleSubmit = () => {
        touchRef.current = true;
        if (!validateData()) {
            addRef.current = true;
            const id = isMobileRecommendation ? (["addition_id", "floor"].includes(entity) ? basicData?.building_id : projectId) : clientId;
            let dataValue = basicData;
            if (
                (entity === "assets.manufacturer" ||
                    (isMobileRecommendation && (entity === "assets.manufacturer_id" || entity === "manufacturer_id"))) &&
                basicData?.client_id !== "06356c0e-2ad9-4af8-8992-83e35233f7d4"
            ) {
                const { client_id, ...rest } = basicData || {};
                dataValue = rest;
            }
            if (fieldData?.[entity]?.serviceFn) dispatch(actions.addDynamicData(() => fieldData?.[entity]?.serviceFn(id, dataValue)));
        }
    };

    return (
        <div
            id="modalId"
            className={`modal modal-region modal-new-build `}
            style={{ display: "block" }}
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <Draggable handle=".draggable" cancel=".not-draggable">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header draggable">
                            <h5 className="modal-title" id="exampleModalLabel">
                                Add New {fieldData?.[entity]?.formHeading}
                            </h5>
                            <button type="button" className="close not-draggable" data-dismiss="modal" aria-label="Close" onClick={onCancel}>
                                <span aria-hidden="true">
                                    <img src="/img/close.svg" alt="" />
                                </span>
                            </button>
                        </div>
                        <div className="modal-body region-otr p-3 pb-4">
                            <div className="dtl-sec col-md-12">
                                <div className="tab-dtl region-mng">
                                    <form autoComplete={"nope"}>
                                        <div className="tab-active build-dtl">
                                            <div className="otr-common-edit custom-col">
                                                <div className="basic-otr">
                                                    <div className="basic-dtl-otr basic-sec">
                                                        {Object.entries(fieldData?.[entity]?.fields ?? {}).map(([fieldKey, fieldValue]) => {
                                                            const fieldType = fieldValue?.fieldType;
                                                            if (
                                                                (entity === "assets.manufacturer" ||
                                                                    (isMobileRecommendation &&
                                                                        (entity === "assets.manufacturer_id" || entity === "manufacturer_id"))) &&
                                                                basicData?.client_id !== "06356c0e-2ad9-4af8-8992-83e35233f7d4" &&
                                                                fieldKey === "client_id"
                                                            ) {
                                                                return null;
                                                            }
                                                            return (
                                                                <div className="col-md-4 basic-box">
                                                                    {fieldType === "text" ? (
                                                                        <div className="codeOtr">
                                                                            <h4>
                                                                                {fieldValue?.label} {fieldValue?.mandatory ? "*" : ""}
                                                                            </h4>
                                                                            <input
                                                                                autoComplete={"nope"}
                                                                                type="text"
                                                                                className={`${
                                                                                    showErrorBorder?.[fieldKey] ? "error-border " : ""
                                                                                }custom-input form-control`}
                                                                                value={basicData?.[fieldKey] ?? ""}
                                                                                onChange={handleChange}
                                                                                disabled={fieldValue?.readOnly}
                                                                                placeholder={`Enter ${fieldValue?.label}`}
                                                                                name={fieldKey}
                                                                            />
                                                                        </div>
                                                                    ) : fieldType === "select" ? (
                                                                        <SelectBox
                                                                            optionsList={
                                                                                getDynamicDropdownDataResponse?.[fieldValue?.dropdownField] ??
                                                                                dropDownOptions?.[fieldValue?.dropdownField] ??
                                                                                fieldValue?.fieldOptions ??
                                                                                []
                                                                            }
                                                                            isRecommendation
                                                                            label={`${fieldValue?.label} ${fieldValue?.mandatory ? "*" : ""}`}
                                                                            value={basicData?.[fieldKey]}
                                                                            disabled={
                                                                                fieldValue?.readOnly ||
                                                                                getDynamicDropdownDataResponseLoading?.[fieldValue?.dropdownField]
                                                                            }
                                                                            handleChange={value =>
                                                                                handleChange({ target: { name: fieldKey, value } })
                                                                            }
                                                                            hasEmptySelect={!["ownership_type"].includes(fieldKey)}
                                                                            isLoading={
                                                                                getDynamicDropdownDataResponseLoading?.[fieldValue?.dropdownField]
                                                                            }
                                                                            showErrorBorder={showErrorBorder?.[fieldKey]}
                                                                        />
                                                                    ) : fieldType === "color" ? (
                                                                        <div class="formInp">
                                                                            <label>Color</label>
                                                                            <div>
                                                                                <div class="close-icon-right position-relative">
                                                                                    <span>
                                                                                        <i class="fas fa-times"></i>
                                                                                    </span>
                                                                                </div>
                                                                                <div style={styles.swatch} onClick={onColorClick}>
                                                                                    <div style={styles.color} />
                                                                                </div>

                                                                                {showPicker ? (
                                                                                    <div style={styles.popover}>
                                                                                        <div style={styles.cover} onClick={onColorClick} />
                                                                                        <SketchPicker
                                                                                            color={basicData?.color_code}
                                                                                            presetColors={[
                                                                                                "#95cd50",
                                                                                                "#ffe242",
                                                                                                "#ffa105",
                                                                                                "#ff0305",
                                                                                                "#0018A8",
                                                                                                "#800080",
                                                                                                "#3E8EDE",
                                                                                                "#417505"
                                                                                            ]}
                                                                                            onChange={e =>
                                                                                                handleChange({
                                                                                                    target: { name: fieldKey, value: e?.hex }
                                                                                                })
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                ) : null}
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="codeOtr">
                                                                            <h4>
                                                                                {fieldValue?.label} {fieldValue?.mandatory ? "*" : ""}
                                                                            </h4>
                                                                            <NumberFormat
                                                                                autoComplete="nope"
                                                                                placeholder={fieldValue?.label}
                                                                                className={`${
                                                                                    showErrorBorder?.[fieldKey] ? "error-border " : ""
                                                                                }custom-input form-control`}
                                                                                onValueChange={values => {
                                                                                    const { value } = values;
                                                                                    handleChange({
                                                                                        target: {
                                                                                            name: fieldKey,
                                                                                            value: value
                                                                                        }
                                                                                    });
                                                                                }}
                                                                                isAllowed={({ value }) =>
                                                                                    fieldValue?.isZeroNotAllowed ? value !== "0" : true
                                                                                }
                                                                                thousandSeparator={true}
                                                                                allowNegative={false}
                                                                                value={basicData?.[fieldKey]}
                                                                                decimalScale={fieldValue?.decimalScale ? fieldValue?.decimalScale : 0}
                                                                                format={!fieldValue?.decimalScale && "######"}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="col-md-12 p-0 text-right btnOtr mt-3">
                                <span className="errorMessage">{errorMessage}</span>
                                <button type="button" className="btn btn-secondary btnClr col-md-4 mr-2" data-dismiss="modal" onClick={onCancel}>
                                    Cancel
                                </button>
                                <button
                                    disabled={addDynamicFormResponseLoading}
                                    onClick={handleSubmit}
                                    type="button"
                                    className="btn btn-primary btnRgion col-md-2"
                                >
                                    {addDynamicFormResponseLoading ? (
                                        <span className="spinner-border spinner-border-sm pl-2" role="status"></span>
                                    ) : (
                                        "Add"
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Draggable>
        </div>
    );
};

export default DynamicForm;
